var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoorAutomatic = function SvgDoorAutomatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.67,
    d: "M4.29 27.91H28.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    stroke: "currentColor",
    strokeWidth: 2.67,
    d: "M11.69 4.09h9.13v23.82h-9.13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.67,
    d: "M5.15 6.09c0-1.1.9-2 2-2h6.89V27.9H7.15a2 2 0 0 1-2-2V6.1Zm13.17-2h7.13a2 2 0 0 1 2 2V25.9a2 2 0 0 1-2 2h-7.13V4.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.44 11.77c0-.54-.6-.83-.96-.46l-3.42 3.4c-.5.49-.5 1.34 0 1.83l3.42 3.4c.37.36.96.08.96-.46v-2.1h3.33a1 1 0 0 0 1-1v-1.75a1 1 0 0 0-1-1H6.44zm19.71 0c0-.54.6-.83.97-.46l3.42 3.4c.5.49.5 1.34 0 1.83l-3.42 3.4c-.37.36-.97.08-.97-.46v-2.1h-3.33a1 1 0 0 1-1-1v-1.75a1 1 0 0 1 1-1h3.33z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.06 14.7 1 13.64l3.42-3.4 1.06 1.07-3.42 3.4Zm0 1.84c-.5-.5-.5-1.34 0-1.84L1 13.64a2.82 2.82 0 0 0 0 3.97L4.42 21c.66.65 1.6.74 2.32.4a2.12 2.12 0 0 0 1.2-1.93v-.6h1.83a2.5 2.5 0 0 0 2.5-2.5v-1.75a2.5 2.5 0 0 0-2.5-2.5H7.94v-.36c0-.86-.48-1.59-1.2-1.93a2.03 2.03 0 0 0-2.32.4l1.06 1.07c.37-.37.96-.08.96.46v1.86h3.33a1 1 0 0 1 1 1v1.75a1 1 0 0 1-1 1H6.44v2.1c0 .54-.6.82-.96.46l-3.42-3.4Zm25.06 3.4c-.37.36-.97.08-.97-.46v-2.1h-3.33a1 1 0 0 1-1-1v-1.75a1 1 0 0 1 1-1h3.33v-1.86c0-.54.6-.83.97-.46l3.42 3.4c.5.49.5 1.34 0 1.83zm-2.47-7.81v-.36c0-.86.5-1.59 1.2-1.93a2.03 2.03 0 0 1 2.33.4l3.42 3.4a2.82 2.82 0 0 1 0 3.97L28.18 21c-.67.65-1.6.74-2.33.4a2.12 2.12 0 0 1-1.2-1.93v-.6h-1.83a2.5 2.5 0 0 1-2.5-2.5v-1.75a2.5 2.5 0 0 1 2.5-2.5h1.83Z",
    clipRule: "evenodd"
  })));
};
export default SvgDoorAutomatic;